<template>
  <RF-Dialog
    :cpntLargura='"900px"'
    :cpntStatus="statusGeral"
    :cpntOnFecharDialog='finConBanDialogFechar'>
    <template slot='titulo'>      
      <div class="dem-nova-titulo">
        <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
        Conciliação bancária
      </div>
    </template>

    <template slot='conteudo'>
      <div class="fin-con-ban-dialog" v-if="[ '', null, undefined ].indexOf(cpntId) === -1">
        <App-Conta-Bancaria-Conciliar :cpntId="cpntId" :cpntFecharFormulario="finConBanDialogFechar"></App-Conta-Bancaria-Conciliar>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
  .fin-con-ban-dialog {
    margin-top: -20px;
  }
</style>

<style>
</style>

<script>
  export default {
    props: {
      cpntId: {
        required: true,
        type: String
      },
      cpntFecharFormulario: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    components: {
      'App-Conta-Bancaria-Conciliar': () => import('@/components/financeiro/Conciliacao/Financeiro-Conciliacao-Bancaria-Conciliar.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: ''
      }
    },
    methods: {
      finConBanDialogFechar: function (atualizar) {
        this.cpntFecharFormulario(atualizar)
      }
    }
  }
</script>
